import {helpEmail, mailto} from '~/data/mercury'
import {externalLinks} from '~/routing/external-links'
import FEMLink from '~/components/FEMLink'
import {grid, gridItem} from '~/design-system/foundations'

export function ErrorBoundaryFallback() {
  return (
    <div className="flex h-svh w-full items-center justify-center">
      <div
        className={grid({
          className: 'mx-auto',
        })}
      >
        <div className={gridItem({size: 'heading'})}>
          <div className="flex flex-col items-center justify-center text-center text-text-default">
            <h1 className="mt-s6 arcadia-display-7">Something isn’t right.</h1>
            <p className="mt-s4 arcadia-body-1">We ran into an unexpected error.</p>
            <p className="mt-s3 arcadia-body-1">
              Please try refreshing, or contact{' '}
              <FEMLink
                variant="revealUnderline"
                href={mailto(helpEmail)}
                className="text-text-primary"
              >
                {helpEmail}
              </FEMLink>{' '}
              if this continues.
            </p>
            <p className="mt-s6 max-w-[400px] arcadia-body-1">
              Existing customer? You can still access your account{' '}
              <FEMLink
                variant="revealUnderline"
                href={externalLinks.auth.login}
                className="text-text-primary"
              >
                here
              </FEMLink>
              .
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}
